import { useMutation, useQueryClient } from "@tanstack/react-query";
import { attemptDeleteBrand } from "../../api/OrgApi";
import { useToast } from "../../context/ToastContext";

export const useDeleteBrand = () => {
  const queryClient = useQueryClient();
  const { setToastMessage } = useToast();

  return useMutation({
    mutationKey: "delete-brand",
    mutationFn: (brandId) => attemptDeleteBrand(brandId),
    onSuccess: (response, brandId) => {
      setToastMessage("Brand deleted successfully");

      // If we have organization ID in the cache, invalidate all brands for that org
      const orgID = queryClient.getQueryData(["user-profile"])?.organisation_id;
      if (orgID) {
        queryClient.invalidateQueries({
          queryKey: ["org-brands", orgID],
        });
      }
    },
    onError: (error) => {
      setToastMessage("Failed to delete brand");
      console.error("Brand deletion error:", error);
    },
  });
};
